<!-- Start Navbar -->
<nav class='navbar navbar-expand-lg' dir='rtl' style='text-align: right'>
	<div class='container'>
		<a class='navbar-brand' routerLink='/estate-ar'>
			<img src='../../assets/images/logo.svg' alt='' class='img-fluid' />
		</a>
		<a href='tel:+201001040090' dir='ltr' class='btn tel d-lg-none d-block'>01001040090</a>
		<button class='navbar-toggler' type='button' data-toggle='collapse' data-target='#navbarSupportedContent'
			aria-controls='navbarSupportedContent' aria-expanded='false' aria-label='Toggle navigation'>
			<i class='fas fa-bars'></i>
		</button>
		<div class='collapse navbar-collapse' id='navbarSupportedContent'>
			<ul class='navbar-nav mr-auto mb-2 mb-lg-0'>
				<li class='nav-item'>
					<a class='nav-link active' aria-current='page' routerLink='/estate-ar'>الرئيسيه</a>
				</li>
				<li class='nav-item'>
					<a class='nav-link' routerLink='/allegria-ar'>ألجريا</a>
				</li>
				<li class='nav-item'>
					<a class='nav-link' href='#'>Estate</a>
				</li>
				<li class='nav-item'>
					<a class='nav-link' routerLink='/vye-ar'>VYE</a>
				</li>
				<li class='nav-item'>
					<a class='nav-link' routerLink='/eastvale-ar'>إيستفيل</a>
				</li>
				<li class='nav-item'>
					<a class='nav-link' (click)='scroll(contact)'>اتصل بنا</a>
				</li>
				<li class='nav-item'>
					<a class='nav-link' href='tel:+201001040090'>

						<span>201001040090+</span> <i class='fas fa-phone'></i>
					</a>
				</li>
				<li class='nav-item'>
					<a class='nav-link btn btn-language' routerLink='/estate-en'>English</a>
				</li>
			</ul>
		</div>
	</div>
</nav>
<main dir='rtl' style='text-align: right;'>
	<!-- Start Header -->
	<section class='header'>
		<div class='card-img-overlay'></div>
		<div class='header-con'>
			<h2>THE ESTATES</h2>
			<h3>UNIVERSE ‘SIGNATURES</h3>
			<p>
				مع منازل مصممة لتعكس أسلوبك وشخصيتك ، universe التوقيعات لا ترتقي بالمعيشة
				المتميزة إلى مستوى جديد.
			</p>
			<button class='btn'>انضم إلينا</button>
		</div>
	</section>
	<section class='the-estate'>
		<div class='container'>
			<div class='row'>
				<div class='col-md-4 mx-auto mb-4'>
					<img src='../../assets/images/The-Estates-logo.svg' alt='' class='img-fluid' />
				</div>
			</div>
			<P>أحدث إصدار من "مجتمعات توقيع universe" The Estates ، يقدم أنت شيء جديد
				تمامًا ، ولكن مع القيم التقليدية في القلب. يقع في زايد الجديدة على بعد 5
				دقائق من universe ويست فريد من نوعه العمارة الريفية المعاصرة والمناظر
				الخضراء الممتدة</P>
		</div>
	</section>
	<section class='imgs'>
		<div class='overly-text'>
			<h3>رفاهية</h3>
			<h4>إعادة اختراع</h4>
			<p>
				يقدم لك The Estates شيئًا جديدًا تمامًا ، ولكنه تقليدي القيم في القلب.
			</p>
		</div>
		<div class='imgs-con'>
			<div class='img-con'></div>
			<div class='img-con'>
				<div class='card-img-overlay'>
					<div class='row'>
						<div class='col-12'>
							<div class='text'>
								<h3>لا يصدق</h3>
								<h3>مساحات المعيشة</h3>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section class='gallery'>
		<div class='container'>
			<div class='row'>
				<div class='col-md-6 mb-4'>
					<div class='img-con' style='background-image: url(../../assets/images/gallery-1.jpg);'></div>
				</div>
				<div class='col-md-6 mb-4'>
					<div class='img-con' style='background-image: url(../../assets/images/gallery-2.jpg);'></div>
				</div>
				<div class='col-md-6'>
					<div class='img-con' style='background-image: url(../../assets/images/gallery-3.jpg);'></div>
				</div>
				<div class='col-md-6'>
					<div class='img-con' style='background-image: url(../../assets/images/gallery-4.jpg);'></div>
				</div>
				<div class='col-12'>
					<h3>داخل العقارات</h3>
					<p>
						مساكن فاخرة غير متفاخرة مستمرة ، تيارات ضوء الشمس من خلال الزجاج
						الحديث المصقول والواسع بينما الأسقف ذات الارتفاع المزدوج تؤكد
						الطوابق السفلية على الشعور بالاتساع.
					</p>
				</div>
			</div>
		</div>
	</section>
	<section class='master-plan'>
		<div class='card-img-overlay'>
			<div class='container h-100'>
				<div class='row h-100'>
					<div class='col-12 my-auto'>
						<h3>مشروع</h3>
						<h3>خطة رئيسية</h3>
					</div>
				</div>
			</div>
		</div>
	</section>
	<section #development class='projects'>
		<div class='container'>
			<div class='row'>
				<div class='col-md-4 mb-4'>
					<a href='#' class='project' style='background-image: url(../../assets/images/Mask1.png);'>
						<div class='text'>
							<h6>فيلا مسطحة</h6>
							<span>خطط المبنى</span>
						</div>
					</a>
				</div>
				<div class='col-md-4 mb-4'>
					<a href='#' class='project' style='background-image: url(../../assets/images/Mask2.png);'>
						<div class='text'>
							<h6>فيلا كبيرة</h6>
							<span>خطط المبنى</span>
						</div>
					</a>
				</div>
				<div class='col-md-4 mb-4'>
					<a href='#' class='project' style='background-image: url(../../assets/images/Mask3.png);'>
						<div class='text'>
							<h6>فيلا متوسطة</h6>
							<span>خطط المبنى</span>
						</div>
					</a>
				</div>
				<div class='col-md-4 mb-4'>
					<a href='#' class='project' style='background-image: url(../../assets/images/Mask4.png);'>
						<div class='text'>
							<h6>فيلا صغيرة</h6>
							<span>خطط المبنى</span>
						</div>
					</a>
				</div>
				<div class='col-md-4 mb-4'>
					<a href='#' class='project' style='background-image: url(../../assets/images/Mask5.png);'>
						<div class='text'>
							<h6>توين فيلا</h6>
							<span>خطط المبنى</span>
						</div>
					</a>
				</div>
				<div class='col-md-4 mb-4'>
					<a href='#' class='project' style='background-image: url(../../assets/images/Mask6.png);'>
						<div class='text'>
							<h6>تاون فيلا</h6>
							<span>خطط المبنى</span>
						</div>
					</a>
				</div>
			</div>
		</div>
	</section>
	<section class='last-section'>
		<div class='container'>
			<div class='row'>
				<div class='col-md-12'>
					<section class='about'>
						<h2>
							حول
							<span>universe</span>
						</h2>
						<p>
							بناء تاريخ لأكثر من عقدين من النجاح عملية في مصر ، universe هي واحدة
							من الشركات الرائدة في البلاد شركات التطوير العقاري. مقرها في
							القاهرة ومدرجة في تقدم universe البورصة المصرية إلى السوق مشاريع
							تطوير واسعة النطاق حائزة على جوائز ، تلبي احتياجات مصر الحاجة
							المتزايدة إلى مساكن عالية الجودة وتجارية وتجزئة المساحات. نحن نفخر
							بأنفسنا لشغفنا بالتميز و الالتزام بتعزيز علاقات طويلة الأمد مع
							عملائنا ، المساهمين وشركاء الأعمال والموظفين ، مما ساعدنا تنمو إلى
							الشركة التي نحن عليها اليوم.
						</p>
					</section>
					<!-- Start Contact -->
					<section #contact class='contact'>
						<h2>
							اتصل
							<span>نحن</span>
						</h2>
						<form [formGroup]='updateForm' (ngSubmit)='onSubmit()'>
							<div class='row'>
								<div class='col-md-6 mb-4'>
									<input type='text' placeholder='الاسم الكامل' title='Full Name' class='form-control'
										formControlName='name' />
									<app-field-error [displayError]="isFieldValid('name')"
										errorMsg='يرجى إدخال اسمك'></app-field-error>
								</div>
								<div class='col-md-6 mb-4'>
									<input type='text' placeholder='عنوان البريد الالكترونى' title='Email Address'
										class='form-control' formControlName='email' />
									<app-field-error [displayError]="isFieldValid('email')"
										errorMsg='من فضلك، أدخل البريد صالح'></app-field-error>
								</div>
								<div class='col-md-12 mb-4'>
									<input type='text' placeholder='رقم الهاتف المحمول' title='Mobile Number'
										class='form-control' formControlName='phone' />
									<app-field-error [displayError]="isFieldValid('phone')"
										errorMsg='يرجى إدخال رقم هاتف صالح'></app-field-error>
								</div>
								<div class='col-md-12 mb-4'>
									<textarea name='Message' title='Message' placeholder='رسالة' class='form-control'
										formControlName='notes'></textarea>
									<app-field-error [displayError]="isFieldValid('notes')"
										errorMsg='يجب أن تكون الرسالة أكثر من 20 حرفًا'></app-field-error>
								</div>
								<div class='col-md-12'>
									<button type='submit' class='btn btn-block' [disabled]='submitted'>
										إرسال
									</button>
								</div>
							</div>
						</form>
					</section>
				</div>
			</div>
		</div>
	</section>
</main>
<!-- Start Footer -->
<footer>
	<div class='container'>
		<div class='row'>
			<div class='col-md-auto my-auto'>
				<h6>اتصل بنا</h6>
				<div class='details'>
					<div>
						<a href='tel:+201001040090'>+201001040090</a>
					</div>
					<div>Sat-Thr 9AM-6PM</div>
					<div class='social'>
						<ul class='list-unstyled'>
							<li>
								<a href='#'>
									<svg xmlns='http://www.w3.org/2000/svg' width='12.447' height='23.239'
										viewBox='0 0 12.447 23.239'>
										<path id='Icon_awesome-facebook-f' data-name='Icon awesome-facebook-f'
											d='M13.24,13.072l.645-4.206H9.85V6.137a2.1,2.1,0,0,1,2.371-2.272h1.835V.284A22.373,22.373,0,0,0,10.8,0C7.476,0,5.3,2.014,5.3,5.661V8.866H1.609v4.206H5.3V23.239H9.85V13.072Z'
											transform='translate(-1.609)' />
									</svg>
								</a>
							</li>
							<li>
								<a href='#'>
									<svg xmlns='http://www.w3.org/2000/svg' width='19.003' height='13.362'
										viewBox='0 0 19.003 13.362'>
										<path id='Icon_awesome-youtube' data-name='Icon awesome-youtube'
											d='M19.656,6.591A2.388,2.388,0,0,0,17.976,4.9a56.428,56.428,0,0,0-7.424-.4,56.428,56.428,0,0,0-7.424.4,2.388,2.388,0,0,0-1.68,1.691,25.048,25.048,0,0,0-.4,4.6,25.048,25.048,0,0,0,.4,4.6,2.352,2.352,0,0,0,1.68,1.664,56.428,56.428,0,0,0,7.424.4,56.428,56.428,0,0,0,7.424-.4,2.352,2.352,0,0,0,1.68-1.664,25.049,25.049,0,0,0,.4-4.6,25.049,25.049,0,0,0-.4-4.6ZM8.608,14.02V8.369l4.967,2.826L8.608,14.02Z'
											transform='translate(-1.05 -4.5)' />
									</svg>
								</a>
							</li>
							<li>
								<a href='#'>
									<svg xmlns='http://www.w3.org/2000/svg' width='18.186' height='18.186'
										viewBox='0 0 18.186 18.186'>
										<path id='Icon_awesome-linkedin' data-name='Icon awesome-linkedin'
											d='M16.887,2.25H1.295A1.3,1.3,0,0,0,0,3.561V19.125a1.3,1.3,0,0,0,1.295,1.311H16.887a1.308,1.308,0,0,0,1.3-1.311V3.561A1.308,1.308,0,0,0,16.887,2.25ZM5.5,17.838H2.8V9.159H5.5v8.679ZM4.149,7.974A1.563,1.563,0,1,1,5.712,6.411,1.564,1.564,0,0,1,4.149,7.974ZM15.6,17.838H12.9V13.616c0-1.007-.02-2.3-1.4-2.3-1.4,0-1.62,1.1-1.62,2.229v4.295h-2.7V9.159H9.775v1.185h.037a2.839,2.839,0,0,1,2.553-1.4c2.728,0,3.235,1.8,3.235,4.137Z'
											transform='translate(0 -2.25)' />
									</svg>
								</a>
							</li>
							<li>
								<a href='#'>
									<svg xmlns='http://www.w3.org/2000/svg' width='19.003' height='15.434'
										viewBox='0 0 19.003 15.434'>
										<path id='Icon_awesome-twitter' data-name='Icon awesome-twitter'
											d='M17.05,7.227c.012.169.012.338.012.506A11.005,11.005,0,0,1,5.981,18.815,11.006,11.006,0,0,1,0,17.066a8.057,8.057,0,0,0,.941.048,7.8,7.8,0,0,0,4.835-1.664,3.9,3.9,0,0,1-3.641-2.7,4.912,4.912,0,0,0,.736.06,4.119,4.119,0,0,0,1.025-.133A3.9,3.9,0,0,1,.772,8.855V8.807a3.922,3.922,0,0,0,1.76.494A3.9,3.9,0,0,1,1.326,4.092,11.071,11.071,0,0,0,9.357,8.168a4.4,4.4,0,0,1-.1-.892A3.9,3.9,0,0,1,16,4.611a7.668,7.668,0,0,0,2.472-.941A3.884,3.884,0,0,1,16.76,5.816,7.808,7.808,0,0,0,19,5.214,8.372,8.372,0,0,1,17.05,7.227Z'
											transform='translate(0 -3.381)' />
									</svg>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			<div class='col-md mx-auto text-center my-md-auto my-3'>
				<img src='../../assets/images/logo.svg' alt='Logo' class='img-fluid' />
			</div>
			<div class='col-md-auto ml-auto my-auto'>
				<h6>شركة</h6>
				<nav>
					<ul class='list-unstyled'>
						<li>
							<a href='#'>تطوير</a>
						</li>
						<li>
							<a href='#'>خدمات</a>
						</li>
						<li>
							<a href='#'>صالة عرض</a>
						</li>
						<li>
							<a href='#'>المشاريع</a>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</div>
</footer>